
import Settings from './Settings/Settings';
import BuyNow from './Settings/BuyNow';
import BuyTogether from './Settings/BuyTogether';
import AddonItems from './Settings/AddonItems';
import ProductBadge from './Settings/ProductBadge';
import ProductPlacement from './Settings/ProductPlacement';
import ContentPlacement from './Settings/ContentPlacement';
import MyAccountDashboard from './Settings/MyAccountDashboard';
import CatalogMode from './Settings/CatalogMode';
import ImportExport from './Settings/ImportExport';
import Tools from './Settings/Tools';
import LogsCharts from './Settings/Logs/LogsCharts';
import LogsTable from './Settings/Logs/LogsTable';
import Feedback from './Feedback';
import FreeVsPro from './FreeVsPro';
export {
    Settings,
    BuyNow,
    BuyTogether,
    AddonItems,
    ProductBadge,
    ProductPlacement,
    ContentPlacement,
    MyAccountDashboard,
    CatalogMode,
    ImportExport,
    Tools,
    LogsCharts,
    LogsTable,
    Feedback,
    FreeVsPro,
};